import React from "react";
import { Link } from 'react-router-dom';
import { FaTiktok } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import isme from "../../assets/Logo ISME.png";
import "./Footer.css";
import 'bootstrap/dist/css/bootstrap.min.css';


const Footer = () => {
  return (
    <div className="footer row g-3">

      <div className="cont-area col-md-4">

        <div className="cont-acred">
          <p>Auditado y verificado por: </p>
          <div className="cont-logo-footer">
            <img src={isme} alt="ISME" />
          </div>
        </div>

        {/* <div className="redes">
          <div>
            <a href="" target="_blank">
              <FaTiktok className="red-icon"/>
            </a>
          </div>
          <div>
            <a href="https://www.facebook.com/CognoseguridadBogota/?mibextid=LQQJ4d&_rdr" target="_blank" className="cl-p" >
              <FaFacebook className="red-icon"/>
            </a>
          </div>
          <div>
            <a href="https://www.instagram.com/cognoseguridad/?next=%2F" target="_blank" className="cl-p">
              <FaInstagram className="red-icon"/>
            </a>
          </div>
          <div>
            <a href="https://wa.link/a2j3c0" target="_blank" className="cl-p">
              <FaWhatsapp className="red-icon"/>
            </a>
          </div>
        </div> */}

      </div>

      <div className="cont-area col-md-4">
        
        <div>
          <div>
            <p>NUESTRA UBICACIÓN</p>
            <div className="cont-map">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3976.592894770532!2d-74.0657423!3d4.6664427!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f9bb3417c7957%3A0x586cb0579abcf647!2sSpartnerg!5e0!3m2!1ses-419!2sco!4v1753467866552!5m2!1ses-419!2sco" 
              width="310"
              height="280"
            ></iframe>
            </div>
          </div>
        </div>
        <div>
          <p>© 2025 STRATEGIC PARTNER GROUP. <br />Todos los derechos reservados.</p>
        </div>
      </div>

      <div className="cont-area col-md-4">
        <div className="cont-links">
          <p><Link to="/home#homeAboutUs">Sobre nosotros</Link></p>
          <p><Link to="/home#homeMAndV">Mision y vision</Link></p>
          <p><Link to="/home#homeAllies">Asociados</Link></p>
          <p><Link to="/home#contact">Contactanos</Link></p>
        </div>
      </div>
      
    </div>
  );
};

export { Footer };